export const employeeNameSpec = [
  {
    form_field_type: 'CUSTOM_COMPONENT',
    label: 'Employee Name',
    name: 'EMPLOYEE_NAME',
    type: 'Integer',
  },
]
